export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js